"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitOpeningMeterReading = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var components_1 = require("../../components");
var ElectricityMeterReadingFormLegacy_1 = require("../../components/ElectricityMeterReadingFormLegacy");
var GasMeterReadingFormLegacy_1 = require("../../components/GasMeterReadingFormLegacy");
var MeterHelp_1 = require("../../components/MeterHelp/MeterHelp");
var copy_1 = require("../../copy");
var section_ids_1 = require("../../section-ids");
var utils_1 = require("../../utils");
var ButtonLooksLikeLink_1 = require("./ButtonLooksLikeLink");
var SubmitOpeningReadingHeader_1 = require("./SubmitOpeningReadingHeader");
var utils_2 = require("./utils");
var howToId = 'how-to';
var SubmitOpeningMeterReading = function (_a) {
    var accountId = _a.accountId, supply = _a.supply, selectedFuel = _a.selectedFuel, latestOpeningReading = _a.latestOpeningReading, supplyIndex = _a.supplyIndex;
    var navigate = (0, ui_tools_1.useNavigate)();
    var supplies = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext).supplies;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _b.copy, Copy = _b.Copy;
    var meterReadsConfirmation = (0, core_1.useLinks)().meterReadsConfirmation;
    var _c = (0, core_1.useComponents)(), ErrorNotification = _c.ErrorNotification, ErrorSummaryNotification = _c.ErrorSummaryNotification, Card = _c.Card, Margin = _c.Margin, Heading1 = _c.Heading1, P = _c.P, Stack = _c.Stack, RadioField = _c.RadioField, Radio = _c.Radio;
    var _d = __read((0, react_1.useState)(null), 2), data = _d[0], setData = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), apiError = _e[0], setApiError = _e[1];
    var _f = __read((0, react_1.useState)([]), 2), errors = _f[0], setErrors = _f[1];
    var _g = __read((0, react_1.useState)('single'), 2), toggle = _g[0], setToggle = _g[1];
    var isMissingMSN = !supply.msn;
    var isMultiRate = isMissingMSN ? toggle === 'multi' : supply.isMultiRate;
    var meterReadingMutation = (0, legacy_queries_1.useOpeningMeterReadingLegacyMutation)({
        accountId: accountId,
    }, function () {
        if (data) {
            (0, utils_1.storeLatestReadingLocal)(data.mpxn);
            setApiError(false);
            screen_reader_route_manager_1.default.beforeRouteChange();
            navigate((0, utils_2.getSuccessRedirectLink)(meterReadsConfirmation(), data, selectedFuel, false, true, supplyIndex || 0, false));
        }
        else {
            throw new Error('Submission data not found');
        }
    }, function () { return setApiError(true); });
    var submit = function () {
        if (data && meterReadingMutation.status !== 'in-progress') {
            setApiError(false);
            meterReadingMutation.mutate(data);
        }
    };
    (0, react_1.useEffect)(submit, 
    // Adding meterReadingMutation as a dependency causes too many re-runs.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]);
    var handleElectricitySubmit = function (elecData) {
        setErrors([]);
        setApiError(false);
        var tiers = elecData.tiers;
        if (isMultiRate) {
            var offPeakTier = tiers.length &&
                tiers.find(function (_a) {
                    var timeOfUseLabel = _a.timeOfUseLabel;
                    return timeOfUseLabel === 'offpeak';
                });
            var peakTier = tiers.length &&
                tiers.find(function (_a) {
                    var timeOfUseLabel = _a.timeOfUseLabel;
                    return timeOfUseLabel === 'peak';
                });
            var offPeakError = (0, utils_2.validateInput)(offPeakTier ? offPeakTier.meterRegisterReading : null);
            var peakError = (0, utils_2.validateInput)(peakTier ? peakTier.meterRegisterReading : null);
            var multirateErrors = [];
            if (offPeakError) {
                multirateErrors.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.offpeak,
                    message: copy(offPeakError.message),
                    errorName: offPeakError.errorName,
                });
            }
            if (peakError) {
                multirateErrors.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.peak,
                    message: copy(peakError.message),
                    errorName: peakError.errorName,
                });
            }
            if (multirateErrors.length) {
                setErrors(multirateErrors);
            }
            else {
                setData(elecData);
            }
        }
        else {
            var _a = __read(tiers, 1), tier = _a[0];
            var message = (0, utils_2.validateInput)(tier ? tier.meterRegisterReading : null, supply.meterNumOfDigits);
            if (message) {
                setErrors([
                    {
                        id: ElectricityMeterReadingFormLegacy_1.ids.anytime,
                        message: copy(message.message, {
                            numOfDigits: supply.meterNumOfDigits,
                        }),
                        errorName: message.errorName,
                    },
                ]);
            }
            else {
                setData(elecData);
            }
        }
    };
    var handleGasSubmit = function (gasData) {
        setErrors([]);
        setApiError(false);
        var reading = gasData ? gasData.gasVolume : null;
        var message = (0, utils_2.validateInput)(reading, supply.meterNumOfDigits);
        if (message) {
            setErrors([
                {
                    id: GasMeterReadingFormLegacy_1.gasIds.gasMeterReadingId,
                    message: copy(message.message, {
                        numOfDigits: supply.meterNumOfDigits,
                    }),
                    errorName: message.errorName,
                },
            ]);
        }
        else if (gasData && gasData.gasVolume) {
            setData(gasData);
        }
    };
    var scrollTo = function (id) {
        var element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement("section", { id: section_ids_1.METER_READINGS_SECTION_ID },
            react_1.default.createElement("div", null,
                react_1.default.createElement(ErrorSummaryNotification, { "data-testid": "error-summary-notification", title: isMultiRate ? (react_1.default.createElement(Copy, { copyKey: "submitPageSummaryTitleMultiRate" })) : (react_1.default.createElement(Copy, { copyKey: "submitPageSummaryTitle" })), id: "error-summary", errors: errors })),
            apiError ? (react_1.default.createElement(ErrorNotification, { id: "api-error", "data-testid": "api-error" },
                react_1.default.createElement(Copy, { copyKey: "apiError" }))) : null,
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
                    react_1.default.createElement(SubmitOpeningReadingHeader_1.SubmitOpeningReadingHeader, { latestOpeningReading: latestOpeningReading, isMissingMSN: isMissingMSN, selectedFuel: selectedFuel, supply: supply, supplies: supplies }),
                    isMissingMSN && selectedFuel === 'electricity' ? (react_1.default.createElement(core_1.Feature, { feature: "omrWithoutMsn" }, function (enabled) {
                        return enabled ? (react_1.default.createElement(RadioField, { name: "meter-rates", label: copy('summaryRateToggle'), defaultValue: toggle, onValueChange: function (value) {
                                setErrors([]);
                                setToggle(value || 'single');
                            } },
                            react_1.default.createElement(Radio, { label: react_1.default.createElement(Copy, { copyKey: "summaryRateToggleSingle" }), id: "single", value: "single", "data-testid": "rate-toggle-single", hint: react_1.default.createElement(Copy, { copyKey: "summaryRateToggleSingleHint" }) }),
                            react_1.default.createElement(Radio, { label: react_1.default.createElement(Copy, { copyKey: "summaryRateToggleMulti" }), id: "multi", value: "multi", "data-testid": "rate-toggle-multi", hint: react_1.default.createElement(Copy, { copyKey: "summaryRateToggleMultiHint" }) }))) : null;
                    })) : null,
                    selectedFuel === 'electricity' ? (react_1.default.createElement(components_1.ElectricityMeterReadingFormLegacy, { currentSupply: supply, isMultiRate: isMultiRate, fuel: selectedFuel, isUpdating: meterReadingMutation.status === 'in-progress', onSubmit: handleElectricitySubmit, errors: {
                            peak: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.peak, errors),
                            offpeak: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.offpeak, errors),
                            anytime: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.anytime, errors),
                            singleDate: null,
                            multiDate: null,
                        } })) : (react_1.default.createElement(components_1.GasMeterReadingFormLegacy, { currentSupply: supply, fuel: selectedFuel, isUpdating: meterReadingMutation.status === 'in-progress', onSubmit: handleGasSubmit, errors: {
                            gasMeterReadingId: (0, nebula_1.getErrorMessage)(GasMeterReadingFormLegacy_1.gasIds.gasMeterReadingId, errors),
                            dateId: null,
                        } }))),
                react_1.default.createElement(Margin, { top: 6 },
                    react_1.default.createElement(P, null,
                        react_1.default.createElement(ButtonLooksLikeLink_1.ButtonLooksLikeLink, { onClick: function () { return scrollTo(howToId); } },
                            react_1.default.createElement(Copy, { copyKey: "submitPageHowToRead" })))))),
        react_1.default.createElement("section", { id: howToId },
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "submitPageHowToReadTitle" })),
                react_1.default.createElement(MeterHelp_1.MeterHelp, { supply: supply, fuelType: selectedFuel }),
                react_1.default.createElement(Margin, { top: 6 },
                    react_1.default.createElement(P, null,
                        react_1.default.createElement(ButtonLooksLikeLink_1.ButtonLooksLikeLink, { onClick: function () { return scrollTo(section_ids_1.METER_READINGS_SECTION_ID); } },
                            react_1.default.createElement(Copy, { copyKey: "submitPageBackToRead" }))))))));
};
exports.SubmitOpeningMeterReading = SubmitOpeningMeterReading;
